import { CheckIcon, CopyIcon } from "lucide-react";
import React, { useState } from "react";
import { Button } from "@/components/ui/button";

interface OutputSectionProps {
	outputText: string;
	error: string | null;
	copySuccess: boolean;
	setCopySuccess: (copySuccess: boolean) => void;
}

export default function OutputSection({
	outputText,
	error,
	copySuccess,
	setCopySuccess,
}: OutputSectionProps) {
	const handleCopy = () => {
		if (!outputText) return;
		navigator.clipboard.writeText(outputText);
		setCopySuccess(true);
		setTimeout(() => setCopySuccess(false), 2000);
	};

	// Formatiert den Output Text so, dass Hauptpunkte und Unterpunkte farblich unterschieden werden
	const formatOutput = (output: string) => {
		if (!output) return null;
		const lines = output.split("\n");
		return lines.map((line, idx) => {
			if (line.trim().startsWith("- ")) {
				return (
					<div
						className="break-words font-mono font-semibold text-blue-600 text-sm dark:text-blue-400"
						key={idx}
					>
						{line}
					</div>
				);
			}
			if (line.trim().startsWith("--")) {
				return (
					<div
						className="break-words font-mono text-sm text-white dark:text-gray-100"
						key={idx}
					>
						{line}
					</div>
				);
			}
			return (
				<div className="break-words font-mono text-gray-100 text-sm" key={idx}>
					{line}
				</div>
			);
		});
	};

	return (
		<section className="card rounded-xl border border-gray-100 p-6 shadow-sm backdrop-blur-sm dark:border-gray-700 dark:bg-gray-800/70">
			<h2 className="mb-4 border-gray-100 border-b pb-2 font-semibold text-gray-800 text-xl dark:border-gray-700 dark:text-gray-100">
				Generierte Bulletpoints
			</h2>
			{outputText ? (
				<div className="input-area relative mt-2 min-h-64 whitespace-pre-wrap rounded-md p-4 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100">
					<Button
						className="absolute top-2 right-2 z-10 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
						onClick={handleCopy}
						size="sm"
						type="button"
						variant="ghost"
					>
						{copySuccess ? <CheckIcon size={18} /> : <CopyIcon size={18} />}
					</Button>
					<div className="flex flex-col gap-1 font-mono text-sm">
						{formatOutput(outputText)}
					</div>
				</div>
			) : (
				<div className="p-6 text-center text-gray-500 dark:text-gray-400">
					Hier werden die generierten Bulletpoints angezeigt.
				</div>
			)}
		</section>
	);
}
